import Enumerable from "linq";
import { useMemo } from "react";
import { AccessFunctionalityTypeEnum } from "../../common/enums/AccessFunctionalityTypeEnum";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { useQueryNotifications } from "../UseQueryNotifications";
import { useAccessFunctionalityData } from "./UseAccessFunctionalityData";
import { getAccessFunctionalityHashes, getAccessFunctionalityMasks, getAccessPermissions } from "../../common/utilities/PermissionsUtils";
import { IAccessFunctionalityHashes } from "../../common/models/IAccessFunctionalityHashes";
import { IAccessFunctionalityData } from "../../common/models/IAccessFunctionalityData";

export function useAccessFunctionality({
    groupID,
    enabled
}: {
    groupID: number;
    enabled: boolean;
}): {
    accessFunctionalityData: IAccessFunctionalityData | undefined;
    accessFunctionalityMasks: Enumerable.IDictionary<eLynxObjectTypeEnum, Enumerable.IDictionary<AccessFunctionalityTypeEnum, number>> | undefined;
    accessFunctionalityHashes: Enumerable.IDictionary<eLynxObjectTypeEnum, IAccessFunctionalityHashes> | undefined;
    accessFunctionalityStatus: "idle" | "error" | "loading" | "success";
} {
    const {
        data: accessFunctionalityData,
        status: accessFunctionalityStatus
    } = useQueryNotifications(useAccessFunctionalityData)({
        groupID: groupID,
        enabled: enabled
    });

    const {
        accessFunctionalityMasks, accessFunctionalityHashes
    } = useMemo(() => {
        if (accessFunctionalityData) {
            const access = getAccessPermissions(accessFunctionalityData);
            const masks = getAccessFunctionalityMasks(access);
            const hashes = getAccessFunctionalityHashes(access);

            return {
                accessFunctionalityMasks: masks,
                accessFunctionalityHashes: hashes
            };
        }

        return {
            accessFunctionalityMasks: undefined,
            accessFunctionalityHashes: undefined
        };
    }, [accessFunctionalityData]);

    return {
        accessFunctionalityData,
        accessFunctionalityMasks,
        accessFunctionalityHashes,
        accessFunctionalityStatus
    };
}
